<div class="tab-container" [ngStyle]="{ width: tabs.length * defaultWidth + 'px' }">
  <div class="active-tab" #activeTab [ngStyle]="{ width: 'calc(' + 100 / tabs.length + '% - 5px)' }"></div>

  <ng-container *ngFor="let tab of tabs; let i = index">
    <button
      class="btn"
      #btn
      [class.active]="activeIndex === i"
      (click)="changeTab(i)"
    >
      {{ tab }}
    </button>
  </ng-container>
</div>
